import { render, staticRenderFns } from "./table-empty.vue?vue&type=template&id=5bfc4d98&scoped=true&"
import script from "./table-empty.vue?vue&type=script&lang=ts&"
export * from "./table-empty.vue?vue&type=script&lang=ts&"
import style0 from "./table-empty.vue?vue&type=style&index=0&id=5bfc4d98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc4d98",
  null
  
)

export default component.exports